import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import amplitude from 'amplitude-js';
import { updateFieldValues, updateFormProperties } from 'apps/auth/actions/formAction';
import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import { Stories } from 'apps/auth/components/common/Layout/Stories/Stories';
import StoryLayout from 'apps/auth/components/common/Layout/Stories/StoryLayout';
import { NOT_NOW_CLICKED, PROMO_SCREEN_SHOWN, TRY_NOW_CLICKED } from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { SCREEN } from 'apps/auth/constants/amplitude/AmplitudeParamName';
import { METHOD_SUGGESTION } from 'apps/auth/constants/amplitude/AmplitudeParamValues';
import { DELIVERY_METHOD } from 'apps/auth/constants/fieldsName';
import { useExtra, useForm, usePageMessages, useTypeOfTransfer } from 'apps/auth/hooks/selectors';
import usePreloadStoryImages from 'apps/auth/hooks/usePreloadStoryImages';
import { GTPaymentMethodService } from 'apps/auth/services/GTPaymentMethodService';

const PaymentStoriesModal = ({
    updateFieldValues,
    updateFormProperties,
    sliders,
    popupFullwidthRef,
    submitRef,
    formName,
    isMarketing,
    sendEvent,
    changePaymentMethod,
    tryToCreatePrecheck,
}) => {
    const { notNowButton, promoButtonTryNow } = usePageMessages();
    const { toCountry, toCurrency, sendStoriesFromProviderCategory, availablePaymentMethodsList, incompleteTransfer } = useExtra();
    const { fields } = useForm(formName);
    const deliveryMethod = fields?.[DELIVERY_METHOD]?.value;
    const imagesLoaded = usePreloadStoryImages(sliders?.slides);
    const typeOfTransfer = useTypeOfTransfer();
    const hasTopButton = sliders?.not_now;
    const promoPaymentMethod = availablePaymentMethodsList[sendStoriesFromProviderCategory];

    const paymentMethodService = useRef(
        new GTPaymentMethodService(
            updateFieldValues,
            updateFormProperties,
            formName,
            toCountry?.code,
            toCurrency?.code,
            deliveryMethod,
            typeOfTransfer,
            incompleteTransfer,
        ),
    );

    useEffect(() => {
        if (sendEvent) {
            amplitude.getInstance().logEvent(PROMO_SCREEN_SHOWN, { [SCREEN]: METHOD_SUGGESTION });
        }
    }, []);

    const closeStories = () => popupFullwidthRef?.current?.close();

    const changeToPromoPaymentMethod = (e) => {
        e.preventDefault();
        paymentMethodService.current.changePaymentMethod(promoPaymentMethod?.method, promoPaymentMethod?.code, () => {
            submitRef.current.click();
            closeStories();
        });
    };

    const getSteps = () => {
        return sliders.slides.map((slide) => (
            <StoryLayout
                key={slide.order}
                topButtonCaption={hasTopButton ? notNowButton : null}
                title={slide.title}
                subtitle={<DangerouslyHtml dangerouslyHtml={slide.subtitle} />}
                variant="secondary_base"
                bottomButtonCaption={promoButtonTryNow}
                imgA={slide.web_a_bg_img_url}
                imgA2x={slide.web_a2x_bg_img_url}
                imgB={slide.web_b_bg_img_url}
                imgB2x={slide.web_b2x_bg_img_url}
                contentPosition={slide.position}
                onTopButtonClick={() => {
                    sendEvent ? amplitude.getInstance().logEvent(NOT_NOW_CLICKED) : null;
                    tryToCreatePrecheck();
                    closeStories();
                }}
                onBottomButtonClick={(e) => {
                    sendEvent ? amplitude.getInstance().logEvent(TRY_NOW_CLICKED) : null;
                    if (isMarketing) {
                        changePaymentMethod();
                    } else {
                        changeToPromoPaymentMethod(e);
                    }
                    closeStories();
                }}
            />
        ));
    };

    return <>{imagesLoaded && <Stories steps={getSteps()} duration={sliders.duration * 1000} isInverted />}</>;
};

PaymentStoriesModal.propTypes = {
    formName: PropTypes.string.isRequired,
    sliders: PropTypes.object.isRequired,
    popupFullwidthRef: PropTypes.object.isRequired,
    submitRef: PropTypes.object.isRequired,
    isMarketing: PropTypes.bool.isRequired,
};
export default connect(null, {
    updateFieldValues,
    updateFormProperties,
})(PaymentStoriesModal);
